import { HolderOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { use } from 'react';
import { TableDragRowContext } from './context';

export function TableDragHandle() {
    const { setActivatorNodeRef, listeners } = use(TableDragRowContext);

    return (
        <Button
            className='cursor-move'
            icon={<HolderOutlined />}
            ref={setActivatorNodeRef}
            size='small'
            type='text'
            {...listeners}
        />
    );
}
